import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 15a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3v-4h4","key":"svg-0"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 8v8","key":"svg-2"}]]

const IconNumber45Small = createReactComponent('outline', 'number-45-small', 'Number45Small', __iconNode);

export default IconNumber45Small;